// extracted by mini-css-extract-plugin
module.exports = {"success":"Success_success__2P_7Y","icon":"Success_icon__3rDt_","info":"Success_info__zBPDs","price":"Success_price__1bMMS","text":"Success_text__wjEPB"};